/**
 * 系统设置 API — LLM API Key 等全局配置的读写。
 */
import client from "./client";

/** 单个设置项（脱敏后）。 */
export interface SettingItem {
  key: string;
  value: string; // 脱敏后的值
  category: string;
  description: string | null;
  is_secret: boolean;
  has_value: boolean;
  updated_by: string | null;
  updated_at: string | null;
}

/** 平台配置（分组后）。 */
export interface PlatformConfig {
  platform: string;
  api_key?: SettingItem;
  endpoint?: SettingItem;
  model?: SettingItem;
}

/** LLM Keys 响应。 */
export interface LlmKeysResponse {
  platforms: PlatformConfig[];
  raw: SettingItem[];
}

/** 监测平台项。 */
export interface MonitorPlatform {
  key: string;
  label: string;
  enabled: boolean;
}

/** 获取全部系统设置。 */
export async function getSettings(category?: string): Promise<SettingItem[]> {
  const params = category ? { category } : {};
  return client.get<unknown, SettingItem[]>("/system/settings", { params });
}

/** 获取 LLM API Key 配置（按平台分组）。 */
export async function getLlmKeys(): Promise<LlmKeysResponse> {
  return client.get<unknown, LlmKeysResponse>("/system/settings/llm-keys");
}

/** 获取监测平台清单（GET /api/system/monitor-platforms）。 */
export async function getMonitorPlatforms(): Promise<MonitorPlatform[]> {
  return client.get<unknown, MonitorPlatform[]>("/system/monitor-platforms");
}

/** 更新单个 LLM 平台配置。 */
export async function updateLlmKeys(
  platform: string,
  data: { api_key?: string; endpoint?: string; model?: string },
): Promise<{ platform: string; updated_fields: string[] }> {
  return client.put<unknown, { platform: string; updated_fields: string[] }>(
    "/system/settings/llm-keys",
    { platform, ...data },
  );
}

// ── 批 10 任务三：引流报告联系区块配置 ──

/** 批量更新系统设置（通用 KV，如 LEADGEN_PHONE）。 */
export async function updateSettings(
  items: { key: string; value: string }[],
): Promise<{ updated: string[]; count: number }> {
  return client.put<unknown, { updated: string[]; count: number }>(
    "/system/settings",
    { settings: items },
  );
}

/** 上传引流报告联系区块二维码（multipart，kind=group/sales，限 png/jpg ≤2MB）。 */
export async function uploadLeadgenQr(
  kind: "group" | "sales",
  file: File,
): Promise<{ key: string; url: string; size: number }> {
  const form = new FormData();
  form.append("file", file);
  return client.post<unknown, { key: string; url: string; size: number }>(
    `/system/settings/leadgen-qr?kind=${kind}`,
    form,
    // 置空 Content-Type，让浏览器自动带 multipart boundary
    { headers: { "Content-Type": undefined } },
  );
}
